import { render, staticRenderFns } from "./VxTooltip.vue?vue&type=template&id=2faa7224"
import script from "./VxTooltip.vue?vue&type=script&lang=js"
export * from "./VxTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2faa7224')) {
      api.createRecord('2faa7224', component.options)
    } else {
      api.reload('2faa7224', component.options)
    }
    module.hot.accept("./VxTooltip.vue?vue&type=template&id=2faa7224", function () {
      api.rerender('2faa7224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/layouts/components/vx-tooltip/VxTooltip.vue"
export default component.exports